<script>
import DropdownMenu from '../DropdownMenu/DropdownMenu.vue';
import {mapActions, mapGetters, mapState} from 'vuex';

export default {
    components: {
        DropdownMenu
    },
    computed: {
        ...mapState({
            site: state => state.dashboard.notifications.filters.site,
            limit: state => state.dashboard.notifications.limit,
            limits: state => state.dashboard.notifications.limits,
            predicate: state => state.dashboard.notifications.filters.predicate,
            predicates: state => state.dashboard.notifications.filters.predicates,
            accommodation: state => state.dashboard.notifications.filters.accommodation
        }),
        ...mapGetters({
            accommodationNotificationsFilters: 'dashboard/getAccommodationNotificationFilters'
        })
    },
    methods: {
        ...mapActions({
            setSelectedFilters: 'dashboard/setSelectedFilters',
            setLimit: 'dashboard/setNotificationLimit'
        }),
    }
}
</script>

<template>
    <div class="dashboard-notifications-filters">
        <div class="dashboard-notifications-filters__options">
            <div class="dashboard-notifications-filters__option">
                <dropdown-menu
                    :label="$t('dashboard.notifications.limit')"
                    :value="limit"
                    :items="limits"
                    :searchable="false"
                    @input="setLimit($event)"/>
            </div>
            <div class="dashboard-notifications-filters__option">
                <dropdown-menu
                    :label="$t('dashboard.notifications.filters.sites.label')"
                    :value="site"
                    :items="accommodationNotificationsFilters.sites"
                    :enable-deselect="true"
                    :undefined-value="$t('dashboard.notifications.filters.sites.all')"
                    @input="setSelectedFilters({site: $event})"/>
            </div>
            <div class="dashboard-notifications-filters__option">
                <dropdown-menu
                    :label="$t('dashboard.notifications.filters.predicate.label')"
                    :value="predicate"
                    :items="predicates"
                    :enable-deselect="true"
                    :undefined-value="$t('dashboard.notifications.filters.predicate.all')"
                    :translation-prefix="'dashboard.notifications.filters.predicate'"
                    :searchable="false"
                    @input="setSelectedFilters({predicate: $event})"/>
            </div>
            <div class="dashboard-notifications-filters__option">
                <dropdown-menu
                    :label="$t('dashboard.notifications.filters.accommodations.label')"
                    :value="accommodation"
                    :items="accommodationNotificationsFilters.accommodations"
                    :enable-deselect="true"
                    :undefined-value="$t('dashboard.notifications.filters.accommodations.all')"
                    @input="setSelectedFilters({accommodation: $event})"/>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/DashboardNotificationsFilters/DashboardNotificationsFilters.vue